import { useTranslation } from "react-i18next";
import { useConsent } from "@/components/consent/ConsentProvider";

// The legal documents live on the landing host (vardic.eu), which owns them;
// the app host no longer serves copies. PL is the authoritative text; EN is an
// unofficial translation. Extensionless URLs are the canonical form on the
// landing host (Cloudflare Pages 308-redirects .html → extensionless), so link
// there directly. The *link target* is locale-aware so EN users are not shown
// the Polish document.
const LEGAL_URLS = {
  pl: {
    privacy: "https://vardic.eu/polityka-prywatnosci",
    terms: "https://vardic.eu/regulamin",
  },
  en: {
    privacy: "https://vardic.eu/privacy-policy",
    terms: "https://vardic.eu/terms-of-use",
  },
} as const;

export default function SettingsLegalSection() {
  const { t, i18n } = useTranslation(["settings"]);
  const { openPreferences } = useConsent();
  const lang = i18n.language === "en" ? "en" : "pl";
  const urls = LEGAL_URLS[lang];

  return (
    <section className="space-y-4 rounded-lg border border-[var(--border)] bg-[var(--card)] p-6">
      <div>
        <h2 className="text-lg font-semibold text-[var(--foreground)]">
          {t("settings:legal.title")}
        </h2>
      </div>

      <div>
        <a
          href={urls.privacy}
          target="_blank"
          rel="noopener noreferrer"
          data-test="settings-privacy-policy-link"
          className="text-sm font-medium text-[var(--primary)] hover:underline"
        >
          {t("settings:legal.privacyPolicy")}
        </a>
        <p className="mt-1 text-xs text-[var(--muted-foreground)]">
          {t("settings:legal.privacyPolicyHint")}
        </p>
      </div>

      <div>
        <a
          href={urls.terms}
          target="_blank"
          rel="noopener noreferrer"
          data-test="settings-terms-of-use-link"
          className="text-sm font-medium text-[var(--primary)] hover:underline"
        >
          {t("settings:legal.termsOfUse")}
        </a>
        <p className="mt-1 text-xs text-[var(--muted-foreground)]">
          {t("settings:legal.termsOfUseHint")}
        </p>
      </div>

      <div>
        <button
          type="button"
          onClick={openPreferences}
          data-test="settings-manage-cookies"
          className="text-sm font-medium text-[var(--primary)] hover:underline"
        >
          {t("settings:legal.manageCookies")}
        </button>
        <p className="mt-1 text-xs text-[var(--muted-foreground)]">
          {t("settings:legal.manageCookiesHint")}
        </p>
      </div>
    </section>
  );
}
